import type { AdminRegistryApp } from '@/api/console';

// EAA-1817: `mostRecentSync` (the previous version of this file) computed
// catalog age by fanning out one `GET /admin/app-roles?application=` request
// per registry row and taking the max `AppRole.last_synced_at` client-side,
// because `Application` carried no sync timestamp of its own. The contract
// this ticket pairs with (portal-api EAA-1840) now injects
// `catalog_last_synced_at`/`catalog_last_sync_status` directly onto
// `GET /admin/apps` (see `AdminRegistryApp` in `@/api/console`), so that N+1
// fan-out is gone from `AppsPage` and this file only ever formats the field
// the registry row already carries.

/** Relative-age label for the "Danh mục" column — `null` reads as never synced. */
export function formatCatalogAge(iso: string | null): string {
    if (!iso) return 'Chưa đồng bộ';
    const syncedAt = new Date(iso).getTime();
    if (Number.isNaN(syncedAt)) return 'Chưa đồng bộ';
    const diffDays = Math.floor((Date.now() - syncedAt) / (24 * 60 * 60 * 1000));
    if (diffDays <= 0) return 'Hôm nay';
    if (diffDays === 1) return '1 ngày trước';
    return `${diffDays} ngày trước`;
}

const CATALOG_STATUS_LABELS: Record<AdminRegistryApp['catalog_last_sync_status'], string> = {
    ok: 'Đã đồng bộ',
    never: 'Chưa đồng bộ',
    failed: 'Đồng bộ lỗi',
};

/** Vietnamese label for `catalog_last_sync_status` — used by the column badge and the toolbar's "Danh mục" facet. */
export function catalogStatusLabel(status: AdminRegistryApp['catalog_last_sync_status']): string {
    return CATALOG_STATUS_LABELS[status];
}

/** `.portal-console-badge` tone class for `catalog_last_sync_status` (`''` renders the neutral default). */
export function catalogStatusTone(status: AdminRegistryApp['catalog_last_sync_status']): string {
    if (status === 'ok') return 'is-on';
    if (status === 'failed') return 'is-fail';
    return '';
}
